<template>
  <form>
    <b-button type="button" class="btn">
      Voir la commande concernée
    </b-button>
    <hr class="bg-dark">
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de remboursement</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Montant</span>
      </div>
      <input disabled type="text" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="etat_activite">Etat de remboursement</label>
      </div>
      <select disabled class="custom-select" id="etat_activite">
        <option>Choose...</option>
        <option selected value="1">Actif</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
  </form>
</template>

<script>
export default {
  name: "Read"
}
</script>

<style lang="scss" scoped>
form{
  & > .btn{
    background-color: var(--color-white, rgba(255, 255, 255, 1));
    color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    border: 1px solid var(--color-curious-blue, rgba(34, 134, 195, 1));
  }
  & > .btn:hover{
    background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    color: var(--color-white, rgba(255, 255, 255, 1));
  }
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/remboursements/components/Read.vue